__turbopack_context__.v({
  "iconWrapper": "Social-module-scss-module__-AOMGa__iconWrapper",
  "social": "Social-module-scss-module__-AOMGa__social",
  "socialLink": "Social-module-scss-module__-AOMGa__socialLink",
});
